<template>
    <div>
        <div ref="captcha" class="g-recaptcha"></div>
        <div class="error" v-for="error in errorCodes">
            {{ error }}
        </div>
    </div>
</template>

<script>import script from './captcha';
    export default script;</script>

<style lang="less" scoped>
    @import "./captcha.less";
</style>